/* Banky Nieuw WP5.2 (PLAN.md #59): leesvoortgang bovenaan een artikel, een lijn van 2px in merkkleur op tint.
   Volgt hoe ver de tekst (.banky-lees__tekst) gelezen is; zichtbaar zodra je in de tekst bent. Alleen vorm: de lijn is
   aria-hidden en verandert niets aan de inhoud. De inhoudsopgave zelf komt uit bankyReading() in banky-sales.js. */
(() => {
  const balk = document.querySelector('[data-banky-lees-voortgang]');
  const tekst = document.querySelector('[data-banky-lees] .banky-lees__tekst');
  if (!balk || !tekst) return;
  let gepland = false;
  const meet = () => {
    gepland = false;
    const r = tekst.getBoundingClientRect();
    const lijn = innerHeight * 0.3;
    const bereik = Math.max(1, r.height - innerHeight * 0.4);
    const deel = Math.min(1, Math.max(0, (lijn - r.top) / bereik));
    balk.style.setProperty('--banky-lees-voortgang', deel.toFixed(4));
    balk.classList.toggle('is-actief', r.top < lijn && r.bottom > 0);
  };
  const plan = () => { if (!gepland) { gepland = true; requestAnimationFrame(meet); } };
  addEventListener('scroll', plan, {passive: true});
  addEventListener('resize', plan, {passive: true});
  meet();
})();
